/**
 * Stats privacy (`/v2/stats/privacy`, SELF) — consent toggles from
 * F6.1 (UserSettings): master view + edit health/HR zone + preview share +
 * default photo visibility (per-photo wins — S-ODL-38).
 */
import type { ApiUpdateStatsPrivacyDto } from '@mfw/common';

import type { ApiStatsPrivacy } from './types/stats.types';

import { patch, get } from './axios';

export const fetchStatsPrivacy = async () => {
  const response = await get<ApiStatsPrivacy>('/v2/stats/privacy');
  return response ?? null;
};

export const updateStatsPrivacy = async (dto: ApiUpdateStatsPrivacyDto) => {
  const response = await patch('/v2/stats/privacy', dto);
  // BE returns a raw body, but the `patch` helper types the `{data}` wrapper — cast
  return (response ?? null) as ApiStatsPrivacy | null;
};
